export enum PayorType {
  payorIsSomeoneElseAndOffline = 'PayorIsSomeoneElseAndOffline',
  payorIsSomeoneElseAndOnline = 'PayorIsSomeoneElseAndOnline',
  applicationPayorMonthly = 'Payment.ApplicationPayorMonthly',
  applicationPayorInitial = 'Payment.ApplicationPayorInitial',
  applicant = 'Applicant',
}
